import {
  OrgsBillingTable,
  If,
  ListSkeleton,
  PageHeader,
  CustomPagination
} from "../../common/ui"
import { useEffect, useState } from "react"
import { useFetchOrgListQuery } from "../../redux/queries"
import { Organizations } from "../../types"
import { useFetchOrgsSystemUsageQuery } from "../../redux/queries"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

const Billing = () => {
  // TODO: implement month selector
  let month

  const [currentPageOrgs, setCurrentPageOrgs] = useState<Organizations>([])

  const {
    data: orgs = [],
    isFetching: isFetchingOrgs,
    isError: isErrorOrgs
  } = useFetchOrgListQuery({ limit: 999 })
  const [sortedOrgs, setSortedOrgs] = useState<Organizations>([])

  // Fetch system usage for each org
  const {
    data: systemUsage = {},
    isFetching: isFetchingUsage,
    isError: isErrorUsage
  } = useFetchOrgsSystemUsageQuery(
    { orgs: currentPageOrgs, month },
    { skip: currentPageOrgs.length === 0 }
  )

  // Sort and filter the orgs
  useEffect(() => {
    if (orgs.length > 0) {
      const filteredOrgs = orgs.filter(org => !org.disabled)
      const sorted = filteredOrgs.sort((a, b) => a.name.localeCompare(b.name))
      setSortedOrgs(sorted)
    }
  }, [orgs])

  // Error state for orgs
  if (isErrorOrgs || isErrorUsage) return <p>Failed to load data.</p>

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE.billing}>
      <>
        <div className="p-6 pt-4 sm:pt-6 border-neutral-200">
          <PageHeader title="Billing" />
        </div>
        <div className="p-6 flex-1 bg-primary-100">
          <ListSkeleton
            containerClassName={`rounded-lg overflow-hidden ${
              isFetchingOrgs || isFetchingUsage ? "" : "hidden"
            }`}
          />

          <div className={isFetchingOrgs || isFetchingUsage ? "hidden" : ""}>
            <If
              condition={!(isFetchingOrgs || isFetchingUsage)}
              then={
                <OrgsBillingTable
                  orgs={currentPageOrgs}
                  systemUsage={systemUsage}
                />
              }
            />
            <CustomPagination<Organizations>
              items={sortedOrgs}
              updateDisplayedItems={setCurrentPageOrgs}
            />
          </div>
        </div>
      </>
    </RequireRole>
  )
}

export default Billing
